<template>
<div>
    <medIntegration :userState="userState" :amountPaid="3" :product_id="product_id" :formType="currentFormType" v-if="activeFrm==1 || activeFrm==2"></medIntegration>
    <refillFormMdi :productPurchased="productName" :currentDose="currentDose" v-else-if="activeFrm==3"></refillFormMdi>
    <div v-if="activeFrm==0" class="loading-overlay2">
        <div class="">
            <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <circle cx="50" cy="50" fill="none" stroke="#2e9bf0" stroke-width="10" r="35" stroke-dasharray="165 57">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                </circle>
            </svg>
        </div>
    </div>
    <div style="height: 440px;"></div>
</div>
</template>

<script>
import medIntegration from "./medIntegration.vue"
import refillFormMdi from "./refillFormMdi.vue"
import {
    getProductById
} from '@/utils/productData'
export default {
    name: 'FormLoader',
    components: {
        medIntegration,
        refillFormMdi
    },
    data() {
        return {
            activeFrm: 0,
            productName: '',
            currentDose: 2.5,
            userState: null,
            product_id: '',
            providerId: '',
            // Add localStorage key for form state persistence
            formStateKey: '',
            // Add flag to track if we're loading from saved state
            loadingFromSavedState: false
        }
    },

    computed: {
        // Create a computed property for the form ID from route params
        formId() {
            return this.$route.params.id;
        },
        // Determine form type based on activeFrm
        currentFormType() {
            return this.activeFrm === 1 ? 'medIntegration' : 'bareMeds';
        }
    },

    watch: {
        // Watch for changes in activeFrm to save state and update URL
        activeFrm: {
            handler(newVal, oldVal) {
                console.log(oldVal)
                if (newVal !== 0) { // Don't save loading state
                    this.saveFormStateToStorage();
                    this.updateUrlWithFormType();
                }
            }
        },

    },

    created() {
        // Initialize storage key based on form ID
        this.initializeStorageKey();

        // Try to load saved form state first
        this.loadFormStateFromStorage();

        // If no saved state found or saved state is invalid, fetch fresh data
        if (!this.loadingFromSavedState) {
            this.getOrder();
        }
    },

    // Add beforeUnload listener to save state when user leaves the page
    beforeMount() {
        window.addEventListener('beforeunload', this.saveFormStateToStorage);
    },

    beforeDestroy() {
        // Clean up event listener
        window.removeEventListener('beforeunload', this.saveFormStateToStorage);
    },

    methods: {
        // Initialize the storage key for this specific form session
        initializeStorageKey() {
            // Create a unique key based on form ID
            this.formStateKey = `formLoader_state_${this.formId}`;
        },

        // Save current form state to localStorage
        saveFormStateToStorage() {
            try {
                const stateData = {
                    activeFrm: this.activeFrm,
                    productName: this.productName,
                    currentDose: this.currentDose,
                    userState: this.userState,
                    product_id: this.product_id,
                    formId: this.formId,
                    savedAt: new Date().toISOString(),
                    version: '1.0'
                };

                localStorage.setItem(this.formStateKey, JSON.stringify(stateData));
                console.log('Form state saved to localStorage', {
                    activeFrm: this.activeFrm,
                    formId: this.formId,
                });
            } catch (error) {
                console.error('Error saving form state to localStorage:', error);
            }
        },

        // Load saved form state from localStorage
        loadFormStateFromStorage() {
            try {
                const savedData = localStorage.getItem(this.formStateKey);

                if (!savedData) {
                    console.log('No saved form state found');
                    return false;
                }

                const stateData = JSON.parse(savedData);

                // Validate the saved data structure
                if (!this.isValidFormStateData(stateData)) {
                    console.warn('Invalid form state data found, fetching fresh data');
                    this.clearFormStateFromStorage();
                    return false;
                }

                // Check if the saved data is too old (e.g., older than 24 hours)
                const savedAt = new Date(stateData.savedAt);
                const now = new Date();
                const hoursSinceLastSave = (now - savedAt) / (1000 * 60 * 60);

                // If data is older than 24 hours, fetch fresh data
                if (hoursSinceLastSave > 24) {
                    console.log('Saved form state is too old, fetching fresh data');
                    this.clearFormStateFromStorage();
                    return false;
                }

                // Check if the form ID matches (user might have navigated to different form)
                if (stateData.formId !== this.formId) {
                    console.log('Form ID mismatch, fetching fresh data');
                    return false;
                }

                // Restore the state data
                this.restoreFormStateData(stateData);
                this.loadingFromSavedState = true;

                console.log('Form state loaded from localStorage', {
                    activeFrm: this.activeFrm,
                    formId: this.formId,
                    savedAt: stateData.savedAt
                });

                // Update URL to reflect current form state
                this.updateUrlWithFormType();

                return true;

            } catch (error) {
                console.error('Error loading form state from localStorage:', error);
                // If there's an error loading saved data, fetch fresh data
                this.clearFormStateFromStorage();
                return false;
            }
        },

        // Validate the structure of saved form state data
        isValidFormStateData(data) {
            return data &&
                typeof data.activeFrm === 'number' &&
                data.formId &&
                data.savedAt &&
                data.version;
        },

        // Restore form state data to component state
        restoreFormStateData(stateData) {
            this.activeFrm = stateData.activeFrm || 0;
            this.productName = stateData.productName || '';
            this.currentDose = stateData.currentDose || 2.5;
            this.userState = stateData.userState || null;
            this.product_id = stateData.product_id || '';

            // Also restore userState to localStorage if it exists
            if (stateData.userState) {
                localStorage.setItem('userState', JSON.stringify(stateData.userState));
            }
        },

        // Clear saved form state from localStorage
        clearFormStateFromStorage() {
            try {
                localStorage.removeItem(this.formStateKey);
                console.log('Form state cleared from localStorage');
            } catch (error) {
                console.error('Error clearing form state from localStorage:', error);
            }
        },

        // Update URL with form type parameter for better navigation
        updateUrlWithFormType() {
            try {
                let formType = '';

                if (this.activeFrm === 1) {
                    formType = 'medical';
                } else if (this.activeFrm === 2) {
                    formType = 'bare';
                } else if (this.activeFrm === 3) {
                    formType = 'refill';
                }

                // Only update URL if we have a form type and it's different from current
                if (formType && this.$route.query.type !== formType) {
                    // Update URL without triggering navigation
                    this.$router.replace({
                        path: this.$route.path,
                        query: {
                            ...this.$route.query,
                            type: formType
                        }
                    }).catch(() => {
                        // Ignore navigation errors (e.g., same route)
                    });
                }
            } catch (error) {
                console.error('Error updating URL:', error);
            }
        },

        resetFormState() {
            this.clearFormStateFromStorage();
            this.activeFrm = 0;
            this.productName = '';
            this.currentDose = 2.5;
            this.userState = null;
            this.product_id = '';
            this.loadingFromSavedState = false;
            this.getOrder();

            console.log('Form state reset');
        },

        async getOrder() {
            try {
                const response = await this.$axios.get(`${process.env.VUE_APP_API_ENDPOINT}/forms/orders/${this.$route.params.id}`);
                if (response.data.status === 'success' && response.data.order.status === 'pending_approval') {
                    const product = getProductById(response.data.order.product_id)[0];
                    this.product_id = response.data.order.product_id;
                    this.userState = response.data.state;
                    this.providerId = response.data.providerId || null;
                    localStorage.setItem('userState', JSON.stringify(response.data.state))
                    if ((response.data.isTriz || response.data.isSema) && response.data.health_id) {
                        this.productName = product.name;
                        this.currentDose = response.data.currentDose;
                        this.activeFrm = 3;
                    } else if (response.data.providerId) {
                        if (response.data.providerId === 1) {
                            this.activeFrm = 1;
                        } else {
                            this.activeFrm = 2;
                        }
                    } else {
                        this.activeFrm = 2;
                    }
                    
                    this.saveFormStateToStorage();

                } else {
                    this.$router.push('/sorry?message=Order not found or the assessment form was already submitted. Login to your dashboard to see details.')
                }
            } catch (error) {
                console.log(error)
                this.$router.push('/sorry?message=An error occurred while fetching your order. Please try again later.')
            }
        },


        goBack() {
            if (this.activeFrm === 1 || this.activeFrm === 2) {
                this.$router.go(-1);
            }
            this.saveFormStateToStorage();
        }
    }
}
</script>